import gql from 'graphql-tag';

export const GET_ASIDE_MENU = gql`
  query AsideMenu {
    asideMenu @client {
      active
    }
  }
`;
